module.exports = __webpack_public_path__ + "images/file_icons_v2/dll-b0a43b5463f3c319882aaae505103432.svg";